"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var utils_1 = require("../../utils");
var destructConstructor_1 = require("../../utils/destructConstructor");
var Model_1 = require("../Model");
var ShipmentComment = /** @class */ (function (_super) {
    __extends(ShipmentComment, _super);
    function ShipmentComment() {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _this = this;
        var config = destructConstructor_1.destructConstructor.apply(void 0, [["id", "parentId", "message", "userSub", "timestamp"]].concat(params));
        _this = _super.call(this, config.id) || this;
        _this.setShipmentId = config.shipmentId;
        _this.setMessage = config.message;
        _this.setParentId = config.parentId;
        _this.setTimestamp = config.timestamp;
        _this.setUserSub = config.userSub;
        return _this;
    }
    ShipmentComment.fetch = function (shipmentCommentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result, sdkResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ShipmentComment.makeRequest("/delivery/private/shipment-comment/" + shipmentCommentId, Model_1.METHOD.GET)];
                    case 1:
                        result = (_a.sent()).result;
                        if (!result) {
                            throw new Error("No shipment comment found with id " + shipmentCommentId);
                        }
                        sdkResult = utils_1.mapShipmentCommentApiToSdk(result);
                        return [2 /*return*/, new ShipmentComment(sdkResult)];
                }
            });
        });
    };
    ShipmentComment.fetchByShipmentId = function (shipmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ShipmentComment.makeRequest("/delivery/private/shipment-comment/", Model_1.METHOD.GET, {
                            filter: {
                                where: {
                                    shipmentId: shipmentId,
                                },
                            },
                        })];
                    case 1:
                        results = (_a.sent()).result;
                        return [2 /*return*/, results.map(function (result) {
                                var sdkResult = utils_1.mapShipmentCommentApiToSdk(result);
                                return new ShipmentComment(sdkResult);
                            })];
                }
            });
        });
    };
    ShipmentComment.prototype.fetchParent = function () {
        return this.fetchNestedModel("setParent", ShipmentComment.fetch, "getParentId");
    };
    ShipmentComment.prototype.fetchManager = function () {
        return this.fetchNestedModel("setManager", __1.Manager.fetchByUserSub, "getUserSub");
    };
    ShipmentComment.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, sdkResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.getId) return [3 /*break*/, 2];
                        return [4 /*yield*/, ShipmentComment.makeRequest("/delivery/private/shipment-comment/", Model_1.METHOD.POST, {
                                message: this.getMessage,
                                parentId: this.getParentId,
                                shipmentId: this.getShipmentId,
                            })];
                    case 1:
                        result = (_a.sent()).result;
                        sdkResult = utils_1.mapShipmentCommentApiToSdk(result);
                        this.setId = sdkResult.id;
                        this.setUserSub = sdkResult.userSub;
                        this.setTimestamp = sdkResult.timestamp;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, ShipmentComment.makeRequest("/delivery/private/shipment-comment/" + this.getId, Model_1.METHOD.PUT, {
                            message: this.getMessage,
                        })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, this];
                }
            });
        });
    };
    ShipmentComment.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getId) return [3 /*break*/, 2];
                        return [4 /*yield*/, ShipmentComment.makeRequest("/delivery/private/shipment-comment/" + this.getId, Model_1.METHOD.DELETE)];
                    case 1:
                        _a.sent();
                        this.setId = undefined;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ShipmentComment.prototype, "getShipmentId", {
        /**
         * GETTERS
         */
        get: function () {
            return this.shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getParentId", {
        get: function () {
            return this.parentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getParent", {
        get: function () {
            return this.checkIfPropertyIsFetched("parent", this.fetchParent);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getMessage", {
        get: function () {
            return this.message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getUserSub", {
        get: function () {
            return this.userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getManager", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "getTimestamp", {
        get: function () {
            return this.timestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setShipmentId", {
        /**
         * SETTERS
         */
        set: function (shipmentId) {
            this.shipmentId = shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setParentId", {
        set: function (parentId) {
            this.parentId = parentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setParent", {
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setMessage", {
        set: function (message) {
            this.message = message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setUserSub", {
        set: function (userSub) {
            this.userSub = userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setManager", {
        set: function (manager) {
            this.manager = manager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentComment.prototype, "setTimestamp", {
        set: function (timestamp) {
            this.timestamp = moment_1.default(timestamp);
        },
        enumerable: true,
        configurable: true
    });
    return ShipmentComment;
}(Model_1.Model));
exports.ShipmentComment = ShipmentComment;
